import React from 'react';
import {SelectField} from 'form-fields';
import GuestsTabGridItem from './Tab_Guest_Grid_Item';
import FAIcon from 'faIcon';
import HostPortalActions from './HostPortalActions';
import 'idempotent-babel-polyfill';

export default class GuestsTabGrid extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			filterList: []
		};
	}

	componentWillMount() {
		//let newList = this.props.guestStatusList.filter(s => s.code)
	}

	createGuests(guest, i) {
		let status = this.props.selectedStatus;
		if(status != null && status.length > 0 && (status != guest.status)) return null;
		return <GuestsTabGridItem key={i} {...this.props} guest={guest} />
	}

	createGuestStatusList() {
		let statusList = this.props.guestStatusList.filter(g => g.code !== "REM");
		let newStatusList = [];
		for( var l = 0; l < statusList.length; l++) {
			newStatusList.push({
				code: statusList[l].code,
				description: this.props.resources[`PWS.MyAccount.AttendanceStatus${statusList[l].code}`]
			});
		}
		return newStatusList;
	}

	render() {
		let Keys = {
			valueKey: 'code',
			nameKey: 'description'
		};
		return (
			<div className="clearfix">
				<div className="formSectionSubTitle input-33" >{this.props.resources['PWS.MyAccount.GuestsTabPartyListLabel']}</div>
				<div className="formSectionSubTitle input-33 guest-filter-title">
					{this.props.resources['PWS.MyAccount.GuestsTabFilterTitle'] + ": "}
					<SelectField
						name="selectedFilter"
						label={this.props.resources['PWS.MyAccount.GuestsTabFilterLabel']}
						value={this.props.selectedStatus}
						optionData={this.createGuestStatusList()}
						keys={Keys}
						handleChange={this.props.setFilter.bind(this)}
						classes="addRemoveMargin"
					/>
				</div>
				{this.props.selectedEventDetails.guests.map(this.createGuests.bind(this))}
				<div className="spacer12"></div>
				<SendButtons {...this.props} />
			</div>
		);
	}
}

class SendButtons extends React.Component {
	constructor(props) {
		super(props);
	}

	sendAllPendingInvites() {
		HostPortalActions.sendAllPendingInvites(this.props.selectedEventDetails.code);
	}

	sendAllReminders() {
		HostPortalActions.sendAllReminders(this.props.selectedEventDetails.code);
	}

	render() {
		if(this.props.selectedEventDetails.eventStatus !== "Active") return null;
		return (
			<div>
				<div className="spacer12"></div>
				<div className="simpleHR"></div>
				<div className="send-all-invite-btn send-invite-btn" onClick={this.sendAllPendingInvites.bind(this)}>
					<FAIcon size={16} fill="#FFF" name="envelope_o" inline={true} />&nbsp;&nbsp;{this.props.resources['PWS.MyAccount.GuestsTabSendAllInvitesButton']}
				</div>
				<div className="send-all-invite-btn send-invite-btn" onClick={this.sendAllReminders.bind(this)}>
					<FAIcon size={16} fill="#FFF" name="envelope_o" inline={true} />&nbsp;&nbsp;{this.props.resources['PWS.MyAccount.GuestsTabSendAllRemindersButton']}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/Tab_Guest_Grid.js